<template>
	<div>
		<el-table :cell-class-name="$moneyCellClass" :data="listData" border stripe style="width: 100%; border-radius: 10px" :header-cell-style="{ textAlign: 'center', backgroundColor: '#b3e0ff' }" :cell-style="{ textAlign: 'center' }" :row-class-name="rowClassName">
			<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
			<el-table-column prop="storeName" label="门店名称"></el-table-column>
			<el-table-column label="提成月份" width="120">
				<template #default="scope">{{ scope.row.year }}年{{ scope.row.month }}月</template>
			</el-table-column>
			<el-table-column prop="employeeName" label="员工" width="120"></el-table-column>
			<el-table-column prop="typeStr" label="提成类型" width="120"></el-table-column>
			<el-table-column prop="money" label="提成金额(元)" width="150"></el-table-column>
			<!-- <el-table-column prop="content" label="提成内容"></el-table-column> -->
			<el-table-column prop="isGrant" label="是否发放" width="100">
				<template #default="scope">
					<el-tag :type="scope.row.isGrant == 1 ? 'success' : 'danger'">{{ scope.row.isGrant == 1 ? "已发放" : "未发放" }}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="grantUserName" label="发放人" width="90"></el-table-column>
			<el-table-column label="发放月份" width="120">
				<template #default="scope">
					<span v-if="scope.row.grantYear && scope.row.grantMonth">{{ scope.row.grantYear }}年{{ scope.row.grantMonth }}月</span>
				</template>
			</el-table-column>
			<el-table-column prop="creator" label="经办人" width="90"></el-table-column>
			<el-table-column prop="createTime" label="经办时间" width="170"></el-table-column>
		</el-table>
	</div>
</template>

<script>
import { GetCommissionList } from "@/api/salaryApi.js";
export default {
	data() {
		return {
			loading: false, // 显示加载
			listData: [],
			highlightKeyId: "", // 需要高亮标注的提成记录 keyId（来自列表点击进入的那条）
			formInline: {
				keyId: ""
			}
		};
	},
	// 注册组件
	components: {},
	created() {},
	computed: {},
	methods: {
		showCommissionReord(val, highlightKeyId) {
			this.formInline.keyId = val;
			this.highlightKeyId = highlightKeyId || "";
			this.getListData();
		},
		// 当前点击进入的提成记录行，使用其他颜色标注
		rowClassName({ row }) {
			if (this.highlightKeyId && row.keyId === this.highlightKeyId) {
				return "commission-highlight";
			}
			return "";
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetCommissionList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>

<style scoped></style>
<style>
/* 订单详情中：从列表点击进入的那条提成记录，用醒目颜色标注 */
.commission-highlight {
	background-color: #fff3cd !important;
}
.commission-highlight:hover > td {
	background-color: #ffe69b !important;
}
</style>
